var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7506 21.5625L11.5 20.8438L14.375 15.8125H18.6875C19.0687 15.8125 19.4344 15.661 19.704 15.3915C19.9735 15.1219 20.125 14.7562 20.125 14.375V5.75C20.125 5.36875 19.9735 5.00312 19.704 4.73353C19.4344 4.46395 19.0687 4.3125 18.6875 4.3125H4.3125C3.93125 4.3125 3.56562 4.46395 3.29603 4.73353C3.02645 5.00312 2.875 5.36875 2.875 5.75V14.375C2.875 14.7562 3.02645 15.1219 3.29603 15.3915C3.56562 15.661 3.93125 15.8125 4.3125 15.8125H10.7812V17.25H4.3125C3.55 17.25 2.81874 16.9471 2.27957 16.4079C1.7404 15.8688 1.4375 15.1375 1.4375 14.375V5.75C1.4375 4.9875 1.7404 4.25623 2.27957 3.71707C2.81874 3.1779 3.55 2.875 4.3125 2.875H18.6875C19.45 2.875 20.1813 3.1779 20.7204 3.71707C21.2596 4.25623 21.5625 4.9875 21.5625 5.75V14.375C21.5625 15.1375 21.2596 15.8688 20.7204 16.4079C20.1813 16.9471 19.45 17.25 18.6875 17.25H15.2087L12.7506 21.5625Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 7.1875H17.25V8.625H5.75V7.1875ZM5.75 11.5H12.9375V12.9375H5.75V11.5Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.61952459e0d524522b662841bd8b7606.svg";
export { ForwardRef as ReactComponent };